import { tickerItems } from "@/mocks/home";

export default function UpdateTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section className="bg-primary-500 text-background-50">
      <div className="mx-auto flex max-w-[1280px] items-center px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 border-r border-background-50/30 py-3 pr-3 text-sm font-medium md:pr-4">
          <i className="ri-live-line text-lg animate-pulse"></i>
          实时更新
        </span>
        <div className="marquee-track relative flex-1 overflow-hidden py-3 pl-3 md:pl-4">
          <div className="animate-marquee flex w-max items-center gap-8">
            {loop.map((item, idx) => (
              <span key={idx} className="flex items-center gap-2 whitespace-nowrap text-sm">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-400"></span>
                <span className="font-medium text-background-50">{item.title}</span>
                <span className="text-background-100/85">{item.episode}</span>
                <span className="text-xs text-background-100/60">{item.time}</span>
              </span>
            ))}
          </div>
        </div>
        <a
          href="#updates"
          className="hidden shrink-0 items-center gap-1 whitespace-nowrap border-l border-background-50/30 py-3 pl-4 text-sm text-background-100 transition-colors hover:text-accent-300 md:flex"
        >
          全部更新
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}